import React from 'react';
import { AlertTriangle, Check } from 'lucide-react';
import { CreditRequestState } from '../../hooks/useCreditRequest';

/**
 * What the click on "Request more credits" did, in Robbie's words: the request
 * is in and what happens next, or it could not be sent and nothing changed.
 * Renders nothing for every other phase.
 */
export interface CreditRequestOutcomeProps {
  state: Pick<CreditRequestState, 'phase' | 'message'>;
  className?: string;
}

export const CreditRequestOutcome: React.FC<CreditRequestOutcomeProps> = ({ state, className = '' }) => {
  const { phase, message } = state;
  if (!message) return null;

  if (phase === 'requested') {
    return (
      <p role="status" className={`m-0 flex items-start gap-s2 text-body-sm text-success-ink ${className}`}>
        <Check className="mt-[2px] h-[13px] w-[13px] shrink-0" aria-hidden="true" />
        {message}
      </p>
    );
  }
  if (phase === 'failed') {
    return (
      <p role="alert" className={`m-0 flex items-start gap-s2 text-body-sm text-danger-ink ${className}`}>
        <AlertTriangle className="mt-[2px] h-[13px] w-[13px] shrink-0" aria-hidden="true" />
        {message}
      </p>
    );
  }
  return null;
};

export default CreditRequestOutcome;
